import React, { Component } from 'react';
import {
    dashboardModuleNames,
    ErrorModuleNames as moduleNames,
} from 'utils/constants/errorBoundary';
import { logger } from 'utils/logger';
import ErrorTemplate from './ErrorTemplate';

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || '';
}

const withErrorBoundary = (
    WrappedComponent,
    moduleName = '',
    errorBoundaryProps = {}
) =>
    class extends Component {
        constructor(props) {
            super(props);
            this.state = { hasError: false };
        }

        static getDerivedStateFromError(error) {
            return { hasError: true };
        }

        componentDidCatch(error, errorInfo) {
            const errorMessage = `ErrorBoundary:${moduleName}:${
                errorBoundaryProps?.displayName ||
                getDisplayName(WrappedComponent)
            }:${error?.message}`;
            logger.error(errorMessage, error, errorInfo);
        }

        render() {
            if (this.state.hasError) {
                return (
                    <ErrorTemplate
                        errorMessage={errorBoundaryProps?.errorMessage}
                        height={errorBoundaryProps?.height}
                    />
                );
            }

            return <WrappedComponent {...this.props} />;
        }
    };

export default withErrorBoundary;

export const ErrorModuleNames = moduleNames;
export const DashboardModules = dashboardModuleNames;
